import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { Spinner, ErrorState, Forbidden } from "@/components/ui/States";
import { errorMessage } from "@/api/client";
import { useAuth } from "./AuthProvider";

export const RETURN_TO_KEY = "omf.returnTo";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { tokens, me, meLoading, meError } = useAuth();
  const location = useLocation();
  if (!tokens) {
    const returnTo = location.pathname + location.search;
    return <Navigate to={`/login${returnTo !== "/" ? `?next=${encodeURIComponent(returnTo)}` : ""}`} replace />;
  }
  if (meLoading && !me) return <Spinner className="h-screen" label="Đang tải phiên làm việc…" />;
  if (meError && !me) {
    return (
      <div className="flex h-screen items-center justify-center">
        <ErrorState message={errorMessage(meError)} onRetry={() => window.location.reload()} />
      </div>
    );
  }
  return <>{children}</>;
}

/** Page-level permission gate: renders an explanation instead of a broken page. */
export function RequirePermission({ anyOf, what, children }: { anyOf: string[]; what: string; children: ReactNode }) {
  const { canAny } = useAuth();
  if (!canAny(...anyOf)) return <Forbidden what={what} />;
  return <>{children}</>;
}
